import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isWastageEnabled: true, // Default value
};

const wastageSlice = createSlice({
  name: "wastage",
  initialState,
  reducers: {
    toggleWastage: (state) => {
      state.isWastageEnabled = !state.isWastageEnabled;
    },
    setWastage: (state, action) => {
      state.isWastageEnabled = action.payload;
    },
  },
});

export const { toggleWastage, setWastage } = wastageSlice.actions;
export default wastageSlice.reducer;
